/**
 * Utilitaires de couleurs avec opacité
 * Variantes de blanc et noir avec différents niveaux d'alpha
 *
 * @module admin/alpha
 */

/**
 * Variantes de blanc avec opacité
 * Utilisées pour les overlays, hovers et bordures sur fond sombre
 */
export const WHITE_ALPHA = {
  5: 'rgba(255, 255, 255, 0.05)',
  8: 'rgba(255, 255, 255, 0.08)',
  10: 'rgba(255, 255, 255, 0.1)',
  12: 'rgba(255, 255, 255, 0.12)',
  15: 'rgba(255, 255, 255, 0.15)',
  18: 'rgba(255, 255, 255, 0.18)',
  20: 'rgba(255, 255, 255, 0.2)',
  25: 'rgba(255, 255, 255, 0.25)',
  30: 'rgba(255, 255, 255, 0.3)',
  35: 'rgba(255, 255, 255, 0.35)',
  40: 'rgba(255, 255, 255, 0.4)',
  50: 'rgba(255, 255, 255, 0.5)',
  60: 'rgba(255, 255, 255, 0.6)',
  70: 'rgba(255, 255, 255, 0.7)',
  72: 'rgba(255, 255, 255, 0.72)',
  80: 'rgba(255, 255, 255, 0.8)',
  90: 'rgba(255, 255, 255, 0.9)',
};

/**
 * Variantes de noir avec opacité
 * Utilisées pour les overlays, ombres et backgrounds subtils
 */
export const BLACK_ALPHA = {
  2: 'rgba(0, 0, 0, 0.02)',
  4: 'rgba(0, 0, 0, 0.04)',
  5: 'rgba(0, 0, 0, 0.05)',
  8: 'rgba(0, 0, 0, 0.08)',
  10: 'rgba(0, 0, 0, 0.1)',
  12: 'rgba(0, 0, 0, 0.12)',
  15: 'rgba(0, 0, 0, 0.15)',
  20: 'rgba(0, 0, 0, 0.2)',
  25: 'rgba(0, 0, 0, 0.25)',
  30: 'rgba(0, 0, 0, 0.3)',
  40: 'rgba(0, 0, 0, 0.4)',
  50: 'rgba(0, 0, 0, 0.5)',
  60: 'rgba(0, 0, 0, 0.6)',
  70: 'rgba(0, 0, 0, 0.7)',
  80: 'rgba(0, 0, 0, 0.8)',
};
